import Global from './classes/global/Global';
import DataTable from './classes/global/DataTable';
import Form from "./classes/global/Form";
import Select2 from './classes/global/Select2';
import FileUpload from './classes/global/FileUpload';
import DatePicker from './classes/global/DatePicker';
import Impersonate from './classes/global/Impersonate';
import Repeater from "./classes/global/Repeater";

window.onerror = function errorHandler(msg, url, line) {
    $("#status").fadeOut();
    $("#preloader").delay(1000).fadeOut("slow");
    return false;
};

window.breakpoints = {
    "xs": {"max": 767},
    "sm": {"max": 991},
    "md": {"max": 1199},
    "lg": {"min": 1200}
};

window.breakpoint = function (breakpoint) {
    if ((!breakpoints[breakpoint].min || ($(window).width() >= breakpoints[breakpoint].min)) &&
        (!breakpoints[breakpoint].max || ($(window).width() <= breakpoints[breakpoint].max))) {
        return true;
    }
    return false;
};

window.SwalToast = Swal.mixin({
    toast: true,
    position: 'top',
    customClass: 'swal2-toast',
    showConfirmButton: false,
    timer: 3000
});

moment.locale($("html").attr("lang"));

window.daterangepickerLocale = {
    format: 'DD/MM/YYYY HH:mm',
    applyLabel: _t('Apply'),
    cancelLabel: _t('Cancel'),
    fromLabel: _t('From'),
    toLabel: _t('To'),
    customRangeLabel: _t('Custom'),
    weekLabel: _t('W')
};

// Flag per evitare inizializzazione multipla
let adminPanelGlobalInitialized = false;

// Funzione per inizializzare il codice jQuery quando disponibile
function initializeAdminPanelGlobalJQueryCode(attempts = 0) {
    const maxAttempts = 100; // Massimo 5 secondi di tentativi
    
    // Verifica che jQuery sia disponibile
    if (typeof $ === 'undefined' || typeof jQuery === 'undefined') {
        if (attempts < maxAttempts) {
            setTimeout(() => initializeAdminPanelGlobalJQueryCode(attempts + 1), 50);
        } else {
            console.error('jQuery non disponibile dopo ' + maxAttempts + ' tentativi, abbandono inizializzazione admin-panel/_global');
        }
        return;
    }
    
    // Evita inizializzazione multipla
    if (adminPanelGlobalInitialized) {
        return;
    }
    
    // Inizializza il resto del codice jQuery per admin-panel/_global
    initializeAdminPanelGlobalJQueryFunctions();
    adminPanelGlobalInitialized = true;
}

// Funzioni che utilizzano jQuery - verranno chiamate quando jQuery è disponibile
function initializeAdminPanelGlobalJQueryFunctions() {
    $(document).ready(function () {
    let globalObj = new Global();
    let form = new Form();
    let dtObj = new DataTable();
    window.dtObject = dtObj; // Rendi dtObject accessibile globalmente per le modali
    let select2Obj = new Select2();
    let fileUploadObj = new FileUpload();
    let datePickerObject = new DatePicker();
    let impersonate = new Impersonate();
    let repeater = new Repeater();
    }); // Fine $(document).ready
} // Fine initializeAdminPanelGlobalJQueryFunctions

// Avvia l'inizializzazione
initializeAdminPanelGlobalJQueryCode();

// Avvia l'inizializzazione quando il DOM è pronto (backup)
document.addEventListener('DOMContentLoaded', function() {
    initializeAdminPanelGlobalJQueryCode();
});



